class ProductOption extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      btnShape: '[data-cta="shape"]',
      btnTopFinish: '[data-cta="top-finish"]',
      btnFrameFinish: '[data-cta="frame-finish"]',
      selected: '[data-selected]'
    };
    this.modal = null;
    this.currentSelection = {};
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    const shapeBtn = this.querySelector(this.selectors.btnShape);
    const topFinishBtn = this.querySelector(this.selectors.btnTopFinish);
    const frameFinishBtn = this.querySelector(this.selectors.btnFrameFinish);

    if (shapeBtn) shapeBtn.addEventListener('click', () => this.openModal('shape'));
    if (topFinishBtn) topFinishBtn.addEventListener('click', () => this.openModal('top-finish'));
    if (frameFinishBtn) frameFinishBtn.addEventListener('click', () => this.openModal('frame-finish'));
  }

  createModal() {
    if (!this.modal) {
      this.modal = new tingle.modal({
        footer: true,
        closeMethods: ['overlay', 'button', 'escape'],
        cssClass: ['product-option-modal'],
        onClose: () => this.modal.setContent('')
      });
    }
    return this.modal;
  }

  openModal(type) {
    const templateEl = this.querySelector(`script[data-type="${type}"]`);
    if (!templateEl) return;

    const modal = this.createModal();
    modal.setContent(templateEl.innerHTML);
    const existingSaveBtn = modal.modalBoxFooter.querySelector('.btn-save');
    if (!existingSaveBtn) { const saveBtn = modal.addFooterBtn('Save', 'tingle-btn tingle-btn--primary btn-save', () => { console.log('Modal closed via Save button'); modal.close(); }); }

    modal.open();

    this.bindModalEvents(type);
  }

  bindModalEvents(type) {
    const radios = this.modal.modalBoxContent.querySelectorAll('input[type="radio"]');
    const lastValue = this.currentSelection[type] || this.querySelector(`[data-selected="${type}"]`)?.textContent.trim();

    radios.forEach(radio => {
      if (radio.value === lastValue) {
        radio.checked = true;
      }

      radio.addEventListener('change', (e) => {
        this.updateSelection(type, e.target);
        this.updateModalPreview(type, e.target);
      });
    });
  }

  updateSelection(type, input) {
    const textEls = this.querySelectorAll(`[data-selected="${type}"]`);
    const imgEls = this.querySelectorAll(`[data-selected="${type}-image"]`);

    textEls.forEach(el => el.textContent = input.value);
    imgEls.forEach(el => {
      if (input.dataset.image) {
        el.src = input.dataset.image;
      }
    });

    this.currentSelection[type] = input.value;
  }

  updateModalPreview(type, input) {
    const modalImg = this.modal.modalBoxContent.querySelector(`[data-selected="${type}-image"]`);
    const modalText = this.modal.modalBoxContent.querySelector(`[data-selected="${type}"]`);

    if (modalImg && input.dataset.image) modalImg.src = input.dataset.image;
    if (modalText) modalText.textContent = input.value;
  }
}

customElements.define('product-options', ProductOption);







class optionElementSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.wrapper = this.querySelector('.scroll--slider');
    this.container = this.querySelector('[scroll-list]');
    this.prevButton = this.querySelector('button[name="prev"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.shadowLeft = this.querySelector('.slider__shadow--left');
    this.shadowRight = this.querySelector('.slider__shadow--right');
    setTimeout(() => {
      this.updateUI();
    }, 100);
    this.container.addEventListener('scroll', this.updateUI.bind(this));
    window.addEventListener('resize', this.updateUI.bind(this));

    this.prevButton.addEventListener('click', () => this.scrollByItem(-1));
    this.nextButton.addEventListener('click', () => this.scrollByItem(1));
  }

  scrollByItem(direction) {
    const firstItem = this.container.querySelector('[scroll-list] > li');
    if (!firstItem) return;
    const scrollAmount =
      (firstItem.offsetWidth +
        parseInt(getComputedStyle(firstItem).marginRight || 0)) * 4;
    this.container.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
  }


  updateUI() {
    const scrollLeft = this.container.scrollLeft;
    const maxScrollLeft = this.container.scrollWidth - this.container.clientWidth;

    // If content fits, disable both buttons
    if (maxScrollLeft <= 0) {
      this.prevButton.disabled = true;
      this.nextButton.disabled = true;
      this.shadowLeft.style.opacity = '0';
      this.shadowRight.style.opacity = '0';
      return;
    }

    const canScrollLeft = scrollLeft > 0;
    const canScrollRight = scrollLeft < maxScrollLeft - 1;

    this.prevButton.disabled = !canScrollLeft;
    this.nextButton.disabled = !canScrollRight;

    this.shadowLeft.style.opacity = canScrollLeft ? '1' : '0';
    this.shadowRight.style.opacity = canScrollRight ? '1' : '0';
  }

}

customElements.define('scroll-element', optionElementSlider);











window.currentSelectionFrameFinish = {};

class FinishFrame extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      tabs: '[data-tab="btn"]',
      contents: '[data-element="main"]',
      childItems: '[data-element="child"] > div',
      dropdown: '.select__select',
      previewImage: '[data-selected="frame-finish-image"]',
      previewTitle: '[data-selected="frame-finish-title"]',
      swatchInput: '[data-element="frame-finish-input"]'
    };
    this.init();
  }

  init() {
    this.tabs = Array.from(this.querySelectorAll(this.selectors.tabs));
    this.contents = this.querySelectorAll(this.selectors.contents);

    this.tabs = this.tabs.filter(tab => {
      const content = this.querySelector(`[data-tab="content-${tab.dataset.id}"]`);
      if (!content || content.querySelectorAll(this.selectors.swatchInput).length === 0) { 
        tab.parentElement.remove(); 
        return false; 
      }
      return true;
    });

    this.tabs.forEach(tab => tab.addEventListener('click', () => this.selectTab(tab)));

    this.contents.forEach(content => {
      const tabId = content.dataset.id;
      const select = content.querySelector(this.selectors.dropdown);

      if (!window.currentSelectionFrameFinish.selectedDropdown) window.currentSelectionFrameFinish.selectedDropdown = {};

      if (select) {
        if (window.currentSelectionFrameFinish.selectedDropdown[tabId]) {
          select.value = window.currentSelectionFrameFinish.selectedDropdown[tabId];
        }
        this.filterSwatches(content, select.value);

        select.addEventListener('change', (e) => {
          const value = e.target.value;
          this.filterSwatches(content, value);
          window.currentSelectionFrameFinish.selectedDropdown[tabId] = value;
        });
      }

      content.querySelectorAll(this.selectors.swatchInput).forEach(input => {
        input.addEventListener('change', () => this.updatePreviewFromInput());
      });
    });

    this.loadSavedOrDefaultTab();
  }

  loadSavedOrDefaultTab() {
    let tabToSelect = null;

    if (window.currentSelectionFrameFinish.selectedTab) {
      tabToSelect = this.tabs.find(t => t.dataset.id === window.currentSelectionFrameFinish.selectedTab);
    }

    if (!tabToSelect && this.tabs.length > 0) {
      tabToSelect = this.tabs[0];
    }

    if (tabToSelect) {
      this.selectTab(tabToSelect, false);
      const firstContent = this.querySelector(`[data-tab="content-${tabToSelect.dataset.id}"]`);
      const firstInput = firstContent ? firstContent.querySelector(this.selectors.swatchInput) : null;
      if (firstInput && !firstInput.checked) firstInput.checked = true;
      this.updatePreviewFromInput();
    }
  }

  selectTab(tab, updateGlobal = true) {
    const id = tab.dataset.id;

    this.tabs.forEach(t => t.classList.remove('active'));
    this.contents.forEach(c => c.classList.add('hidden'));

    tab.classList.add('active');

    const content = this.querySelector(`[data-tab="content-${id}"]`);
    if (content) {
      content.classList.remove('hidden');
      const select = content.querySelector(this.selectors.dropdown);
      if (select) this.filterSwatches(content, select.value);
    }

    if (updateGlobal) window.currentSelectionFrameFinish.selectedTab = id;
  }

  filterSwatches(content, value) {
    const childItems = content.querySelectorAll(this.selectors.childItems);
    childItems.forEach(div => {
      if (div.dataset.type === value) div.classList.remove('hidden');
      else div.classList.add('hidden');
    });
    this.updatePreviewFromInput();
  }

  updatePreviewFromInput() {
    const selectedInput = this.querySelector(`${this.selectors.swatchInput}:checked`);
    if (!selectedInput) return;

    const imageSrc = selectedInput.dataset.image || '';
    const titleText = selectedInput.dataset.title || '';

    document.querySelectorAll(this.selectors.previewImage).forEach(img => img.src = imageSrc);
    document.querySelectorAll(this.selectors.previewTitle).forEach(title => title.textContent = titleText);
  }
}

customElements.define('product-frame-finish', FinishFrame);









window.currentSelectionTopFinish = window.currentSelectionTopFinish || {};

class TopFinish extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      tabs: '[data-tab="btn"]',
      contents: '[data-element="main"]',
      childItems: '[data-element="child"] > div',
      dropdown: '.select__select',
      previewImage: '[data-selected="top-finish-image"]',
      previewTitle: '[data-selected="top-finish-title"]',
      swatchInput: '[data-element="top-finish-input"]',
      previewDescription: '[data-selected="top-finish-description"]'
    };
    this.init();
  }

  init() {
    this.tabs = Array.from(this.querySelectorAll(this.selectors.tabs));
    this.contents = Array.from(this.querySelectorAll(this.selectors.contents));

    // Remove tabs and their content if no swatches exist
    this.tabs = this.tabs.filter(tab => {
      const content = this.querySelector(`[data-tab="content-${tab.dataset.id}"]`);
      if (!content || content.querySelectorAll(this.selectors.swatchInput).length === 0) {
        tab.parentElement.remove();
        if (content) content.remove();
        return false;
      }
      return true;
    });

    this.tabs.forEach(tab => tab.addEventListener('click', () => this.selectTab(tab)));

    this.contents.forEach(content => {
      const tabId = content.dataset.id;
      const select = content.querySelector(this.selectors.dropdown);

      if (!window.currentSelectionTopFinish.selectedDropdown) window.currentSelectionTopFinish.selectedDropdown = {};

      if (select) {
        if (window.currentSelectionTopFinish.selectedDropdown[tabId]) {
          select.value = window.currentSelectionTopFinish.selectedDropdown[tabId];
        }
        this.filterSwatches(content, select.value);

        select.addEventListener('change', (e) => {
          const value = e.target.value;
          this.filterSwatches(content, value);
          window.currentSelectionTopFinish.selectedDropdown[tabId] = value;
        });
      }

      content.querySelectorAll(this.selectors.swatchInput).forEach(input => {
        input.addEventListener('change', () => this.updatePreviewFromInput());
      });
    });

    this.loadSavedOrDefaultTab();
  }

  loadSavedOrDefaultTab() {
    let tabToSelect = null;

    if (window.currentSelectionTopFinish.selectedTab) {
      tabToSelect = this.tabs.find(t => t.dataset.id === window.currentSelectionTopFinish.selectedTab);
    }

    if (!tabToSelect && this.tabs.length > 0) {
      tabToSelect = this.tabs[0];
    }

    if (tabToSelect) {
      this.selectTab(tabToSelect, false);
      const firstContent = this.querySelector(`[data-tab="content-${tabToSelect.dataset.id}"]`);
      const firstInput = firstContent ? firstContent.querySelector(this.selectors.swatchInput) : null;
      if (firstInput && !firstInput.checked) firstInput.checked = true;
      this.updatePreviewFromInput();
    }
  }

  selectTab(tab, updateGlobal = true) {
    const id = tab.dataset.id;

    this.tabs.forEach(t => t.classList.remove('active'));
    this.contents.forEach(c => c.classList.add('hidden'));

    tab.classList.add('active');

    const content = this.querySelector(`[data-tab="content-${id}"]`);
    if (content) {
      content.classList.remove('hidden');
      const select = content.querySelector(this.selectors.dropdown);
      if (select) this.filterSwatches(content, select.value);
    }

    if (updateGlobal) window.currentSelectionTopFinish.selectedTab = id;
  }

  filterSwatches(content, value) {
    const childItems = content.querySelectorAll(this.selectors.childItems);
    childItems.forEach(div => {
      if (div.dataset.type === value) div.classList.remove('hidden');
      else div.classList.add('hidden');
    });
    this.updatePreviewFromInput();
  }

  updatePreviewFromInput() {
    const selectedInput = this.querySelector(`${this.selectors.swatchInput}:checked`);
    if (!selectedInput) return;

    const imageSrc = selectedInput.dataset.image || '';
    const titleText = selectedInput.dataset.title || '';

    document.querySelectorAll(this.selectors.previewImage)?.forEach(img => img.src = imageSrc);
    document.querySelectorAll(this.selectors.previewTitle)?.forEach(title => title.textContent = titleText);
    document.querySelectorAll(this.selectors.previewDescription)?.forEach(desc => desc.textContent = descriptionText);
  }
}

customElements.define('product-top-finish', TopFinish);
